<div class="alert alert-info" role="alert">
    <a title="RelationTableSelect" href="https://wiki.westermanngruppe.de/pages/viewpage.action?pageId=290650023" target="_blank">{{ "instruction" | transloco }}</a>
</div>

<h2 mat-dialog-title>Neues Modul anlegen</h2>

<div class="pixl-form">
    <mat-dialog-content [formGroup]="form" class="grid">

        <mat-form-field class="full-width">
            <mat-label>Title</mat-label>
            <input matInput formControlName="title" />
        </mat-form-field>

        <mat-form-field class="full-width">
            <mat-label>Status</mat-label>
            <mat-select formControlName="status">
                <mat-option value="Edit">Edit</mat-option>
                <mat-option value="Live">Live</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="full-width">
            <mat-label>Pre-Title</mat-label>
            <input matInput formControlName="preTitle" />
        </mat-form-field>

        <mat-form-field class="full-width">
            <mat-label>Description</mat-label>
            <textarea matInput formControlName="description"></textarea>
        </mat-form-field>

        <div class="border-area full-width">
            <pixl-relation-table-select
                    [dialogWidth]="'1400px'"
                    [label]="'learning_units'"
                    [dialogTitle]="'selection'"
                    [searchLabel]="'search_by_id_or_title'"
                    [columns]="learningUnitColumns"
                    [displayColumn]="'title'"
                    [loadFn]="loadLearningUnitsFn"
                    [reorderable]="true"
                    [(selectedItems)]="selectedLearningUnits"
                    (selectionChange)="onLearningUnitsChanged($event)"
            >
            </pixl-relation-table-select>
        </div>

    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-button (click)="cancel()">Abbrechen</button>
        <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">
            Speichern
        </button>
    </mat-dialog-actions>
</div>